import { render, staticRenderFns } from "./committee.vue?vue&type=template&id=75b88e50&scoped=true&"
import script from "./committee.vue?vue&type=script&lang=js&"
export * from "./committee.vue?vue&type=script&lang=js&"
import style0 from "./committee.vue?vue&type=style&index=0&id=75b88e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b88e50",
  null
  
)

export default component.exports